/**
 * React hook for consuming the presence store.
 * Uses useSyncExternalStore for tear-free reads.
 */
import { useSyncExternalStore, useMemo } from 'react';
import { subscribe, getSnapshot, getUserPresence, isUserOnline } from './presenceStore';

export function usePresence(userGuid?: string) {
  const snapshotVersion = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  // If a specific user is requested, return their status
  const userStatus = useMemo(() => {
    void snapshotVersion; // recompute when the presence store snapshot changes (store read below)
    if (!userGuid) return 'offline';
    return getUserPresence(userGuid);
  }, [userGuid, snapshotVersion]);

  const isOnline = useMemo(() => {
    void snapshotVersion; // recompute when the presence store snapshot changes (store read below)
    if (!userGuid) return false;
    return isUserOnline(userGuid);
  }, [userGuid, snapshotVersion]);

  return {
    userStatus,
    isOnline,
  };
}
